import React, { useContext, useState, useRef, useEffect, useMemo } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { ArrowBackIos, ArrowForwardIos, Event, School, Assignment, Report, People, CloudOff, HowToReg, Description } from "@mui/icons-material";
import { AppContext } from '../main';


const iconMap = {
  "Event Calendar": <Event fontSize="small" style={{ marginRight: 5 }} />,
  "Parent Portal": <School fontSize="small" style={{ marginRight: 5 }} />,
  "Required Postings": <Assignment fontSize="small" style={{ marginRight: 5 }} />,
  "Bully/Incident Reporting System": <Report fontSize="small" style={{ marginRight: 5 }} />,
  "Staff Directory": <People fontSize="small" style={{ marginRight: 5 }} />,
  "School Closures": <CloudOff fontSize="small" style={{ marginRight: 5 }} />,
  "Enroll Now": <HowToReg fontSize="small" style={{ marginRight: 5 }} />,
  "Request Transcripts": <Description fontSize="small" style={{ marginRight: 5 }} />,
};

const ResponsiveMenu = ({ menu }) => {
  const scrollRef = useRef(null);

  // Scroll left
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  // Scroll right
  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  return (
    <Container fluid className="menu-container">
      <Row className="align-items-center">
        {/* Left Scroll Button */}
        <Col xs="auto">
          <Button variant="light" className="scroll-btn" onClick={scrollLeft}>
            <ArrowBackIos fontSize="small" />
          </Button>
        </Col>

        {/* Scrollable Menu */}
        <Col className="menu-items-wrapper">
          <div className="menu-items d-flex flex-nowrap overflow-auto" ref={scrollRef}>
            {menu.map((item, index) => (
              <a
                key={index}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="menu-item"
              >
                {iconMap[item.title] || "🔗"} {item.title}
              </a>
            ))}
          </div>
        </Col>

        {/* Right Scroll Button */}
        <Col xs="auto">
          <Button variant="light" className="scroll-btn" onClick={scrollRight}>
            <ArrowForwardIos fontSize="small" />
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

// Custom Styles for the Menu
const MenuStyles = ({ colors }) => {  // Convert to component with colors prop
  const styles = `
    .menu-container {
      background-color: ${colors.containerBg};
      border-radius: 8px;
    }

    .menu-items-wrapper {
      overflow: hidden;
      flex: 1;
    }

    .menu-item {
      display: inline-flex;
      align-items: center;
      padding: 10px 15px;
      margin: 5px;
      color: ${colors.itemText || 'white'};
      background-color: ${colors.itemBg || '#000000'};
      text-decoration: none;
      border-radius: 5px;
      font-size: 16px;
      transition: background 0.3s;
    }

    .menu-item:hover {
      background-color: ${colors.itemHoverBg || '#0056b3'};
    }

    .scroll-btn {
      display: flex;
      flex: 1;
      border-radius: 50%;
      font-size: 18px;
      background-color: ${colors.scrollBtnBg || '#000000'};
      color: ${colors.scrollBtnText || '#ffffff'};
      align-items: center;
      justify-content: center
    }

    /* ... existing media queries ... */
  `;
  return <style>{styles}</style>;
};



const MenuLinksA = (props) => {
  const {
    handleEditItem,
    propmenu
  } = props

  const { appState
  } = useContext(AppContext);
  const {
    menuas: conextMenu
    , editMode = false
  } = appState

  const menuas = useMemo(() => {
    return propmenu ? propmenu : conextMenu
  }, [
    propmenu
  ])

  const [colors, setColors] = useState({
    containerBg: 'rgb(43, 44, 44)',
    itemBg: '#000000',
    itemText: '#ffffff',
    itemHoverBg: '#0056b3',
    scrollBtnBg: '#000000',
    scrollBtnText: '#ffffff'
  });

  const [bgColor, setBgColor] = useState('#1E1F22');


  const handleColorChange = (e) => {
    const newColor = e.target.value;
    setBgColor(newColor);

    // Update all elements with bg-dark-1 class
    document.querySelectorAll('.bg-dark-1').forEach(element => {
      element.style.backgroundColor = newColor;
    });

    // Update body background
    document.body.style.backgroundColor = newColor;

    // Update any elements using the CSS variable
    document.documentElement.style.setProperty('--bg-dark-1', newColor);
  };

  useEffect(() => {
    document.querySelectorAll('.bg-dark-1').forEach(element => {
      element.style.backgroundColor = bgColor;
    });

    // Update body background
    document.body.style.backgroundColor = bgColor;

    // Update any elements using the CSS variable
    document.documentElement.style.setProperty('--bg-dark-1', bgColor);
  }, [])


  if (!menuas?.menuas) {
    return null
  }




  return (
    <>
      <MenuStyles colors={'rgba(0,0,0,0)'} />
      <ResponsiveMenu menu={menuas?.menuas} />
    </>
  );
}

export default MenuLinksA